/**
 * Salvation Service Hooks
 * React hooks for accessing Salvation Management services.
 */
import { useCCMS } from '../useCCMS';
/** Access all Salvation Management services: `{ salvationLookups, salvationMe, salvationAdmin }`. */
export function useSalvationServices() {
    const { services } = useCCMS();
    if (!services?.salvation) {
        throw new Error('Salvation services not available. Ensure CCMSProvider is configured.');
    }
    return services.salvation;
}
/** Lookups and public portal settings. */
export function useSalvationLookupsService() {
    return useSalvationServices().salvationLookups;
}
/** Volunteer portal (api/salvation/me). */
export function useSalvationMeService() {
    return useSalvationServices().salvationMe;
}
/** Console admin (api/salvation/admin). */
export function useSalvationAdminService() {
    return useSalvationServices().salvationAdmin;
}
//# sourceMappingURL=useSalvationServices.js.map